import { Component, EventEmitter, Input, Output } from '@angular/core';
import { BusinessCardDragEvent } from './business-card-renderer.component';
import {
  BusinessCardElementId,
  BusinessCardLogoSection,
  BusinessCardSide,
  BusinessCardTextSection,
  QrCodeRecord
} from './app.types';

@Component({
  selector: 'app-business-card-preview',
  standalone: false,
  templateUrl: './business-card-preview.component.html'
})
export class BusinessCardPreviewComponent {
  @Input() visible = false;
  @Input({ required: true }) selectedSide!: BusinessCardSide;
  @Input() textSections: BusinessCardTextSection[] = [];
  @Input() logoSections: BusinessCardLogoSection[] = [];
  @Input() qrCodes: QrCodeRecord[] = [];
  @Input() qrImages: Record<number, string> = {};
  @Input() backgroundStyle: Record<string, string> = {};
  @Input() showGrid = false;
  @Input() gridStyle: Record<string, string> = {};
  @Input({ required: true }) elementStyle!: (elementId: BusinessCardElementId) => Record<string, string>;
  @Input({ required: true }) qrElementId!: (qrCode: QrCodeRecord) => string;

  @Output() selectedSideChange = new EventEmitter<BusinessCardSide>();
  @Output() editText = new EventEmitter<string>();
  @Output() dragStart = new EventEmitter<BusinessCardDragEvent>();
  @Output() dragMove = new EventEmitter<PointerEvent>();
  @Output() dragStop = new EventEmitter<PointerEvent>();
  @Output() removeLogo = new EventEmitter<string>();
}
